import React from 'react';
import {
  List, Datagrid, TextField,
  EditButton
} from 'react-admin';

import SearchFilter from '../components/SearchFilter';

export default (props) => (
  <List {...props} filters={<SearchFilter />}>
    <Datagrid>
      <TextField source="name" />
      <TextField source="identifier" />
      <EditButton />
    </Datagrid>
  </List>
);
